import { cep } from "./masks";

export const generateAddressFiliacao = (endereco) => {
  if (!endereco) return "";

  const logradouro = endereco?.logradouro && endereco?.logradouro !== "-" ? `${endereco.logradouro},` : "";
  const numeroResidencia = endereco?.numeroResidencia ? `nº ${endereco.numeroResidencia}, ` : "";
  const bairroNome = endereco?.bairro?.nome ? `${endereco.bairro.nome}, ` : "";
  const municipio = endereco?.municipio?.nome ? `${endereco.municipio.nome}, ` : "";
  const estadoNome = endereco?.estado?.nome ? endereco.estado.nome + "-" : "";
  const estadoSigla = endereco?.estado?.sigla ? endereco.estado.sigla : "";
  const cepFormat = endereco?.cep ? `CEP:${cep(endereco.cep)}` : "";
  const pontoReferencia = endereco?.pontoReferencia ? endereco.pontoReferencia : "";
  const complemento = endereco?.complemento ? endereco.complemento : "";

  return `${logradouro} ${numeroResidencia} ${bairroNome} ${municipio} ${estadoNome} ${estadoSigla} ${complemento} ${cepFormat} ${pontoReferencia}`.trim();
}